var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"other-area"},[_c('div',{staticClass:"margin-left-2td3"},[_vm._v(" 部门标识 ")]),_c('div',{staticClass:"door"})])}]

export { render, staticRenderFns }